export default __webpack_public_path__ + "static/media/polygon.534d7899.png";